import { getTicketOptionsFilter } from '@/constants/options/ticket.option';
import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            { key: 'name', trans: 'name', defaultOperator: 'like' },
            { key: 'email', trans: 'email', defaultOperator: 'like' },
            { key: 'address', trans: 'address', defaultOperator: 'like' },
            {
                key: 'phoneNumber',
                trans: 'phoneNumber',
                defaultOperator: 'like',
            },
        ],
        type: 'input',
        value: [],
    },
    {
        key: [
            { key: 'createdDate', trans: 'createdDate', defaultOperator: '=' },
        ],
        type: 'date',
        value: [],
    },
    {
        key: [
            {
                key: 'id',
                trans: 'Customers',
                keyService: 'Customers',
                defaultOperator: '=',
                excludeRoles: [RoleEnum.CUSTOMER],
            },
        ],
        type: 'orm',
        value: [],
    },
    {
        key: [
            {
                key: 'tickets.some.ticketStatus',
                trans: 'ticketStatus',
                defaultOperator: '=',
            },
        ],
        type: 'select',
        value: getTicketOptionsFilter(),
    },
];
